import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import clsx from 'clsx';
import { FunctionComponent, MouseEvent } from 'react';
import styles from './ThreeDotsDropdownListItem.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThreeDotsDropdownOption } from './ThreeDotsDropdownOption';

interface ThreeDotsDropdownListItemProps {
    label: string;
    icon?: IconDefinition;
    disabled?: boolean;
    onClick: () => void;
    className?: string;
}

export const ThreeDotsDropdownListItem: FunctionComponent<ThreeDotsDropdownListItemProps> = props => {
    const clickHandler = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        !props.disabled && props.onClick();
    };

    return (
        <div
            className={clsx(styles.container, { [styles.disabledCotainer]: props.disabled }, props.className)}
            onClick={clickHandler}
        >
            {props.icon && (
                <FontAwesomeIcon
                    icon={props.icon}
                    fontSize={14}
                    color={props.disabled ? '#a3a3a3' : '#222'}
                    className={styles.icon}
                />
            )}
            <span className={clsx(styles.label, { [styles.disabledLabel]: props.disabled })}>{props.label}</span>
        </div>
    );
};

export default ThreeDotsDropdownListItem;
